import styles from '/builds/sitegeist/cts-reisen/.build/releases/1/src/Cts.CtsReisenDe.SchoolTrips/Resources/Private/Fusion/Application/SchoolTripRFQForm/SchoolTripRFQForm.css';
import script from '/builds/sitegeist/cts-reisen/.build/releases/1/src/Cts.CtsReisenDe.SchoolTrips/Resources/Private/Fusion/Application/SchoolTripRFQForm/SchoolTripRFQForm.tsx';

export const prototypeName = 'KOVLrrvjlGFbNOD9dNqviz29LVQkL4t39q5qrJDAFNerDKP3pGI1jN7A4LPJS4yQApNxJZt9R2Z2GDQlTVZeGqOOkxczj7VMz';
export {styles};
export {script};